/* jshint esversion: 6 */
/* jshint esversion: 9 */
/* jshint esversion: 11 */
/* jshint ignore:start */

import React, { useContext, useEffect, useState, useRef, useLayoutEffect } from 'react';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import axios from 'axios';
import ImageLoad from './ImageLoad';
import Slider from "react-slick";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { showToast } from '../../showTost';
import { useTranslation } from 'react-i18next';
import { motion } from "framer-motion";
import ImgPrev from './ImgPrev';
const Details = () => {

    const { t } = useTranslation();
    const { BaseUrl, totalcart, setTotalCart } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [maindata, setMainData] = useState([]);
    const [servicedata, setServiceData] = useState([]);
    const [addonlist, setAddonList] = useState([]);
    const [errortext, setErrorText] = useState("");
    const [selectid, setSelectId] = useState("");
    const [isshow, setIsShow] = useState(false);
    const [selectaddon, setSelectAddon] = useState([]);
    const [addonprice, setAddonPrice] = useState(0);
    const [localcart, setLocalCart] = useState([]);
    const [isadd, setIsAdd] = useState(false);
    const [extradata, setExtraData] = useState([]);
    const [imgPrev, setImgPrev] = useState("");

    const sectionRefs = useRef({});
    const HomeRef = useRef(false);
    const navigate = useNavigate();
    const Location = useLocation();
    const { path, name, pid } = Location.state;

    const Currency = secureLocalStorage.getItem("currency");
    const LocalData = secureLocalStorage.getItem("Productid");
    const { cid, title, sub_title, childcat_id } = JSON.parse(LocalData) || [];

    useEffect(() => {
        servicedata?.forEach((section) => {
            if (!sectionRefs.current[section.childcat_id]) {
                sectionRefs.current[section.childcat_id] = React.createRef();
            }
        });
    }, [servicedata]);

    useEffect(() => {

        const localData = secureLocalStorage.getItem("Localdata");
        let matchData = [];
        let notMatchData = [];

        if (localData) {
            try {
                const jsonData = JSON.parse(localData);

                if (Array.isArray(jsonData)) {
                    const matchedService = jsonData.find(item => item.service_id === cid);
                    notMatchData = jsonData.filter(item => item.service_id !== cid);
                    if (matchedService && Array.isArray(matchedService.cartdata)) {
                        matchData = matchedService.cartdata;
                    }
                }
            } catch (error) {
                console.error("Error parsing local data:", error);
            }
        }

        setExtraData(notMatchData);
        setTotalCart(matchData.length);
        setLocalCart(matchData);
        HomeRef.current = false;
        handleFetchData(matchData);

        setTimeout(() => {
            handleScrollToSection(childcat_id);
        }, 1000);

    }, [Location, LocalData]);

    useEffect(() => {
        document.body.style.overflow = isshow ? "hidden" : "auto";
    }, [isshow]);

    useEffect(() => {
        const TotalPrice = selectaddon.reduce((sum, item) => sum + Number(item.price), 0);
        setAddonPrice(TotalPrice);
    }, [selectaddon]);

    useEffect(() => {
        if (!isadd) return;
        if (localcart.length >= 1) {
            const LocalCartData = [...extradata];
            const CartData = {
                service_id: cid,
                service_title: title,
                cartdata: localcart,
                pid
            };
            LocalCartData.push({ ...CartData });
            secureLocalStorage.setItem("Localdata", JSON.stringify(LocalCartData));
            setIsAdd(false);
        } else {
            secureLocalStorage.removeItem("Localdata");
        }
        setTotalCart(localcart.length);
    }, [localcart]);

    useEffect(() => {
        document.body.style.overflow = imgPrev ? "hidden" : "auto";
    }, [imgPrev])

    const handleFetchData = (LocalService) => {
        if (HomeRef.current) return;
        HomeRef.current = true;

        const uid = secureLocalStorage.getItem("Userid") || "0";

        axios.post(`${BaseUrl}tcapi/s_child_list.php`, { uid, cid, sid: "0" })
            .then((res) => {
                if (res.data.ResponseCode !== "200") {
                    setErrorText(res.data.ResponseMsg);
                    return;
                }
                setMainData(res.data.Childcatdata);
            })
            .catch((error) => {
                console.error("s_child_list.php", error);
            });

        axios.post(`${BaseUrl}tcapi/s_service_list.php`, { uid, cid, sid: "0" })
            .then((res) => {
                const ServiceData = res.data.Servicelistdata;
                const FilterItem = ServiceData.map(item => {
                    const ServiceList = item.Service_list.map(list => {
                        const IsMatch = LocalService.find(data => data.id === list.service_id);
                        if (IsMatch) {
                            return { ...list, totalcart: IsMatch.qty };
                        }
                        return list;
                    });
                    return { ...item, Service_list: ServiceList };
                });
                setServiceData(FilterItem);
                setTimeout(() => {
                    setLoading(false);
                }, 500);
            })
            .catch((error) => {
                console.error("s_service_list.php", error);
            });

        axios.post(`${BaseUrl}tcapi/list_addon.php`, { uid, cid })
            .then((res) => {
                setAddonList(res.data.Addondata);
            })
            .catch((error) => {
                console.error("list_addon.php", error);
            });
    };

    const handleScrollToSection = (id) => {
        setSelectId(id);
        const sectionRef = sectionRefs.current[id];
        if (sectionRef && sectionRef.current) {
            const yOffset = -140;
            const y = sectionRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    const handleGetPrice = (item) => {
        return item.service_price - (item.service_discount / 100) * item.service_price;
    };

    const handleAllFuction = (index, item) => {
        const Userid = secureLocalStorage.getItem("Userid");

        if (!Userid) {
            navigate("/Login");
            return;
        }

        if (index === 1) {
            handleAddToCart(item);
        } else if (index === 2) {
            handleDencrement(item);
        } else if (index === 3) {
            handleIncrement(item);
        }
    };

    const handleIncrement = (data) => {

        const FilterData = servicedata.map(item => {
            const ServiceList = item.Service_list.map(list => {
                if (list.service_id === data.service_id) {
                    if (list.service_mqty == list.totalcart) {
                        showToast({ title: t("ReachOut max quantity !!"), id: "info" });
                        return list;
                    }
                    const Qty = list.totalcart + 1;
                    return { ...list, totalcart: Qty };
                }
                return list;
            });
            return { ...item, Service_list: ServiceList };
        });

        const LocalFilter = localcart.map(item => {
            if (item.id === data.service_id) {
                if (item.qty == data.totalcart) {
                    return item;
                }
                const qty = item.qty + 1;
                const allTotal = item.allTotal * qty;
                return { ...item, qty, allTotal };
            }
            return item;
        });

        setIsAdd(true);
        setLocalCart(LocalFilter);
        setServiceData(FilterData);
    };

    const handleDencrement = (data) => {

        const FilterData = servicedata.map(item => {
            const ServiceList = item.Service_list.map(list => {
                if (list.service_id === data.service_id) {
                    const Qty = list.totalcart - 1;
                    return { ...list, totalcart: Qty };
                }
                return list;
            });
            return { ...item, Service_list: ServiceList };
        });

        const LocalFilter = localcart.map(item => {
            if (item.id === data.service_id) {
                const allTotal = item.allTotal - handleGetPrice(item);
                const qty = item.qty - 1;
                if (qty === 0) return null;
                return { ...item, qty, allTotal };
            }
            return item;
        }).filter(Boolean);

        setIsAdd(true);
        setLocalCart(LocalFilter);
        setServiceData(FilterData);
    };

    const handleAddToCart = (data) => {

        let LocalItem;

        const FilterData = servicedata.map(item => {
            const ServiceList = item.Service_list.map(list => {
                if (list.service_id === data.service_id) {
                    LocalItem = { id: list.service_id, service_id: list?.service_id, title: list.service_title, service_mqty: list.service_mqty, allTotal: handleGetPrice(list), cost: list.service_price, qty: 1, discount: list.service_discount };
                    return { ...list, totalcart: 1 };
                }
                return list;
            });
            return { ...item, Service_list: ServiceList };
        });

        setServiceData(FilterData);
        setIsAdd(true);
        setLocalCart(prev => [...prev, LocalItem]);
        handleClearState();
    };

    const handleClearState = () => {
        setSelectAddon([]);
        setAddonPrice(0);
        setIsShow(false);
    };

    const handleNavigate = () => {
        if (selectaddon.length <= 0) {
            showToast({ title: t("Please select services !!"), id: "info" });
            return;
        }
        document.body.style.overflow = "auto";
        secureLocalStorage.setItem("addonlist", JSON.stringify(selectaddon));
        navigate("/checkout", { state: { path: "/details", name: title } });
    };

    return (
        <div className="details_page">

            {loading
                ? <div className="w-full h-[calc(100vh-85px)] bg-white z-[777] fixed flex items-center justify-center">
                    <div className="loader"></div>
                </div>
                :
                <div className="width_container">

                    <div className="py-[20px] bg-white sticky top-[85px] z-[666] max-_430_:hidden">
                        <div className="flex items-center justify-between">
                            <div className="border-[2px] rounded-[50px] px-[15px] py-[3px] cursor-pointer hover:bg-gray-800 group">
                                <Link className="flex items-center gap-[8px] group-hover:text-white" to="/" data-discover="true">
                                    <svg width="10" height="12" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.35401 8.64601C5.54901 8.84101 5.54901 9.15804 5.35401 9.35304C5.25601 9.45104 5.12801 9.49903 5.00001 9.49903C4.87201 9.49903 4.74401 9.45004 4.64601 9.35304L0.646006 5.35304C0.451006 5.15804 0.451006 4.84101 0.646006 4.64601L4.64601 0.646006C4.84101 0.451006 5.15804 0.451006 5.35304 0.646006C5.54804 0.841006 5.54804 1.15804 5.35304 1.35304L1.70704 4.99903L5.35401 8.64601Z" fill="currentColor"></path>
                                    </svg>
                                    <h1 className="font-bold">{t("Home")}</h1>
                                </Link>
                            </div>
                            <div className="flex items-center gap-[10px] font-[500]">
                                <Link className="text-gray-600" to={path} state={Location?.state?.List}>{t(name)}</Link>
                                <svg width="10" height="12" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.35401 5.35401L1.35401 9.35401C1.25601 9.45201 1.12801 9.50001 1.00001 9.50001C0.87201 9.50001 0.744006 9.45101 0.646006 9.35401C0.451006 9.15901 0.451006 8.84198 0.646006 8.64698L4.292 5.00099L0.646006 1.35499C0.451006 1.15999 0.451006 0.842959 0.646006 0.647959C0.841006 0.452959 1.15804 0.452959 1.35304 0.647959L5.35304 4.64796C5.54904 4.84196 5.54901 5.15801 5.35401 5.35401Z" fill="#25314C"></path>
                                </svg>
                                <h1 className="text-gray-400">{title}</h1>
                            </div>
                        </div>
                    </div>

                    {errortext
                        ? <div className="w-full h-[400px] flex items-center justify-center">
                            <h1 className="font-[600] text-[20px] text-gray-600">{errortext}</h1>
                        </div>
                        : <div className="flex flex-wrap items-start justify-center gap-[100px] max-_1025_:gap-[20px] max-_1145_:gap-[40px]">

                            <div className="section_1">
                                <div className="leading-[30px] overflow-hidden">
                                    <h1 className="title line-clamp-2 overflow-ellipsis">{title}</h1>
                                    <p className="text-[15px] text-gray-500">{sub_title}</p>
                                </div>

                                <div className="main_box">
                                    <h1 className="font-[600] text-[17px] text-gray-500">{t("Select a service")}</h1>
                                    <div className="flex flex-wrap items-start gap-[20px] mt-[20px]">
                                        {maindata?.map((item, index) => {
                                            const isSelect = selectid === item.childcat_id;
                                            return <div key={index} onClick={() => handleScrollToSection(item.childcat_id)} className="card_box">
                                                <div className={`bg-[#f5f5f5] rounded-[10px] p-[10px] ${isSelect ? "border-[2px] border-black" : ""}`}>
                                                    <ImageLoad BaseUrl={BaseUrl} url={item.img} />
                                                </div>
                                                <p className="text-center text-[14px] leading-4 mt-[10px]">{item.title}</p>
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>

                            <div className="section_2">
                                {servicedata?.map((item, index) => {
                                    return <div key={index} ref={sectionRefs.current[item.childcat_id]} className="card_box">
                                        <h1 className="font-[600] text-[20px]">{item.title} ({item.Service_list.length})</h1>
                                        <div className="my-[20px]">
                                            {item.Service_list.map((item, index) => {
                                                return <ItemComponent key={index} index={index} BaseUrl={BaseUrl} item={item} addonlist={addonlist} handleAllFuction={handleAllFuction} setImgPrev={setImgPrev} />
                                            })}
                                        </div>
                                        <div className="bg-gray-100 w-full h-[10px]"></div>
                                    </div>
                                })}
                            </div>

                        </div>}

                </div>
            }

            {totalcart !== 0 && <div className="w-full fixed flex left-0 right-0 justify-center bottom-0 items-end">
                <button onClick={() => setIsShow(true)} className=" w-[400px] px-[20px] py-[15px] bg-black">
                    <div className="flex items-center justify-between gap-[10px]">
                        <h1 className="text-white font-[600]">{totalcart} {t("item added")}</h1>
                        <div className="flex items-center gap-[10px]">
                            <h1 className="text-white font-[600]">{t("VIEW CART")}</h1>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.25 22.5C17.2165 22.5 18 21.7165 18 20.75C18 19.7835 17.2165 19 16.25 19C15.2835 19 14.5 19.7835 14.5 20.75C14.5 21.7165 15.2835 22.5 16.25 22.5Z" fill="white" />
                                <path d="M8.25 22.5C9.2165 22.5 10 21.7165 10 20.75C10 19.7835 9.2165 19 8.25 19C7.2835 19 6.5 19.7835 6.5 20.75C6.5 21.7165 7.2835 22.5 8.25 22.5Z" fill="white" />
                                <path d="M4.84 3.94L4.64 6.39C4.6 6.86 4.97 7.25 5.44 7.25H20.75C21.17 7.25 21.52 6.93 21.55 6.51C21.68 4.74 20.33 3.3 18.56 3.3H6.27C6.17 2.86 5.97 2.44 5.66 2.09C5.16 1.56 4.46 1.25 3.74 1.25H2C1.59 1.25 1.25 1.59 1.25 2C1.25 2.41 1.59 2.75 2 2.75H3.74C4.05 2.75 4.34 2.88 4.55 3.1C4.76 3.33 4.86 3.63 4.84 3.94Z" fill="white" />
                                <path d="M20.5101 8.75H5.17005C4.75005 8.75 4.41005 9.07 4.37005 9.48L4.01005 13.83C3.87005 15.54 5.21005 17 6.92005 17H18.0401C19.5401 17 20.8601 15.77 20.9701 14.27L21.3001 9.6C21.3401 9.14 20.9801 8.75 20.5101 8.75Z" fill="white" />
                            </svg>
                        </div>
                    </div>
                </button>
            </div>}

            {isshow && <div onClick={handleClearState} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} className="addon_box">

                    <div className="p-[20px]">
                        <div className="border-b-[1px] border-black pb-[10px]">
                            <p className="font-bold text-[22px] text-gray-800">{t("Customise your service")}</p>
                        </div>
                    </div>

                    <div className="h-full scroll_container">
                        <div className="bg-white mx-[20px] mb-[20px] p-[10px] rounded-[10px]">
                            {addonlist?.map((item, index) => {
                                return <AddonItem key={index} item={item} currency={Currency} setSelectAddon={setSelectAddon} selectaddon={selectaddon} />
                            })}
                        </div>
                    </div>

                    <div className="p-[20px] bg-white">

                        <div className="flex items-center justify-between gap-[10px]">
                            <div className="leading-[15px]">
                                <h1 className="font-[500] text-[16px]">{t("Total Price")}</h1>
                                <p className="font-bold">{Currency}{addonprice}</p>
                            </div>

                            <div style={{ width: "200px" }}>
                                <button onClick={handleNavigate} className="w-full py-[8px] rounded-[10px] text-white font-bold bg-[--bgcolor]">{t("ADD TO CART")}</button>
                            </div>

                        </div>

                    </div>

                </div>
            </div>}


            {imgPrev && <div className="imgprev_box">
                <ImgPrev imgList={imgPrev} setImgPrev={setImgPrev} />
            </div>}

        </div >
    )
}

export default Details

const ItemComponent = ({ index, BaseUrl, item, handleAllFuction, setImgPrev }) => {

    const [showMore, setShowMore] = useState(false);
    const [showButton, setShowButton] = useState(false);

    const { t } = useTranslation();
    const contentRef = useRef(null);

    const isAdded = item.totalcart >= 1;
    const Currency = secureLocalStorage.getItem("currency");
    const settings = {
        dots: true,
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
    };

    const servicesDesc = item.service_sdesc;

    useLayoutEffect(() => {
        if (contentRef.current) {
            const fullHeight = contentRef.current.scrollHeight;
            if (fullHeight > 48) {
                setShowButton(true);
            }
        }
    }, [servicesDesc]);

    const handleGetPrice = () => {
        return item.service_price - (item.service_discount / 100) * item.service_price;
    }

    const handleGetTime = (totalMinutes) => {
        if (totalMinutes <= "60") {
            return `${totalMinutes} mins`;
        }
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        const formattedMinutes = minutes.toString().padStart(2, '0');
        return `${hours} hrs ${hours !== 1 ? 's' : ''} ${formattedMinutes} mins`;
    }

    if (item.service_s_show === "3" || item.service_s_show === "2") {
        return (
            <div className={`product_box ${index !== 0 ? "border-t-[1px]" : ""}`}>
                <div>
                    {item.service_s_show === "3" && <video
                        src={BaseUrl + item.service_video} className="w-full h-full overflow-hidden rounded-[10px]"
                        autoPlay
                        muted
                        loop
                    />}
                    {item.service_s_show === "2" && <div>
                        <div className="slider-container ">
                            <Slider {...settings}>
                                {item.service_img.map((List, index) => {
                                    return <div key={index} onClick={() => setImgPrev(item.service_img)} className="relative cursor-pointer">
                                        <ImageLoad BaseUrl={BaseUrl} url={List} CustomeStyle={"w-full h-[300px] max-_430_:h-[220px] object-cover rounded-[10px]"} />
                                        <div className="absolute inset-0 bg-shadow rounded-[10px]"></div>
                                    </div>
                                })}
                            </Slider>
                        </div>
                    </div>}
                </div>
                <div className="py-[10px]">
                    <div className="flex items-center justify-between">
                        <div>
                            <h1 className="font-[500] text-[17px]">{item.service_title}</h1>
                            <div className="flex items-center gap-[10px] text-[14px]">
                                <p className="font-[600]">{Currency}{handleGetPrice()}</p>
                                <span className="line-through text-gray-600">{Currency + item.service_price}</span>
                                <span className="text-gray-600">• {handleGetTime(item.service_ttken)}</span>
                                <div className="flex items-center gap-[2px]">
                                    <svg width="17" height="17" className="text-[#FFAD01]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.962 4.59601L14.904 8.513C15.05 8.808 15.332 9.01202 15.659 9.05902L20.1419 9.70697C20.9639 9.82597 21.292 10.834 20.697 11.412L17.456 14.557C17.219 14.787 17.111 15.118 17.167 15.443L17.9079 19.747C18.0579 20.62 17.1409 21.286 16.3549 20.875L12.467 18.84C12.175 18.687 11.827 18.687 11.536 18.84L7.65096 20.873C6.86396 21.285 5.94393 20.618 6.09493 19.743L6.83602 15.443C6.89202 15.118 6.78396 14.787 6.54696 14.557L3.30599 11.412C2.70999 10.834 3.03792 9.82597 3.86092 9.70697L8.34395 9.05902C8.66995 9.01202 8.95196 8.808 9.09896 8.513L11.041 4.59601C11.432 3.80101 12.568 3.80101 12.962 4.59601Z" fill="currentColor" />
                                    </svg>
                                    <p className="font-medium">{item.service_rating}</p>
                                </div>
                            </div>
                        </div>
                        <div className="text-center w-[116px]">
                            {isAdded
                                ? <div className="add_btn">
                                    <button onClick={() => handleAllFuction(2, item)}>-</button>
                                    <span className="py-[5px]">{item.totalcart}</span>
                                    <button onClick={() => handleAllFuction(3, item)}>+</button>
                                </div>
                                : <button onClick={() => handleAllFuction(1, item)} className="btn_add w-full">{t("ADD")}</button>}
                        </div>
                    </div>
                    <motion.div
                        ref={contentRef}
                        initial={{ height: 48 }}
                        animate={{ height: showMore ? "auto" :48 }}
                        transition={{ duration: 0.4, ease: "easeInOut" }}
                        className="text-[14px] mt-[5px] overflow-hidden"
                        dangerouslySetInnerHTML={{ __html: servicesDesc }}
                    />
                    {showButton && <div>
                        <button onClick={() => setShowMore(!showMore)} className="text-[14px] font-medium">{showMore ? "Show less" : "Show more"}</button>
                    </div>}
                </div>
            </div>
        )
    } else {
        return (
            <div className={`product_box flex items-start justify-between ${index !== 0 ? "border-t-[1px]" : ""}`}>
                <div className="">
                    <h1 className="font-[500] text-[17px]">{item.service_title}</h1>
                    <div className="flex items-center gap-[10px] text-[14px]">
                        <p className="font-[600]">{Currency}{handleGetPrice()}</p>
                        <span className="line-through text-gray-600">{Currency + item.service_price}</span>
                        <span className="text-gray-600">• {handleGetTime(item.service_ttken)}</span>
                        <div className="flex items-center gap-[2px]">
                            <svg width="17" height="17" className="text-[#FFAD01]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.962 4.59601L14.904 8.513C15.05 8.808 15.332 9.01202 15.659 9.05902L20.1419 9.70697C20.9639 9.82597 21.292 10.834 20.697 11.412L17.456 14.557C17.219 14.787 17.111 15.118 17.167 15.443L17.9079 19.747C18.0579 20.62 17.1409 21.286 16.3549 20.875L12.467 18.84C12.175 18.687 11.827 18.687 11.536 18.84L7.65096 20.873C6.86396 21.285 5.94393 20.618 6.09493 19.743L6.83602 15.443C6.89202 15.118 6.78396 14.787 6.54696 14.557L3.30599 11.412C2.70999 10.834 3.03792 9.82597 3.86092 9.70697L8.34395 9.05902C8.66995 9.01202 8.95196 8.808 9.09896 8.513L11.041 4.59601C11.432 3.80101 12.568 3.80101 12.962 4.59601Z" fill="currentColor" />
                            </svg>
                            <p className="font-medium">{item.service_rating}</p>
                        </div>
                    </div>
                    <motion.div
                        ref={contentRef}
                        initial={{ height: 85 }}
                        animate={{ height: showMore ? "auto" : 85 }}
                        transition={{ duration: 0.4, ease: "easeInOut" }}
                        className="text-[14px] mt-[5px] overflow-hidden"
                        dangerouslySetInnerHTML={{ __html: servicesDesc }}
                    />
                    {showButton && <div className="">
                        <button onClick={() => setShowMore(!showMore)} className="text-[14px] font-medium">{showMore ? "Show less" : "Show more"}</button>
                    </div>}
                </div>
                <div className="image_box">
                    <div onClick={() => setImgPrev(item.service_img)}>
                        <ImageLoad BaseUrl={BaseUrl} url={item.service_img[0]} CustomeStyle={"w-full h-[140px] object-cover rounded-[10px] cursor-pointer"} />
                    </div>
                    <div className="w-[80%] -mt-[20px]">
                        {isAdded
                            ? <div className="add_btn">
                                <button onClick={() => handleAllFuction(2, item)}>-</button>
                                <span className="py-[5px]">{item.totalcart}</span>
                                <button onClick={() => handleAllFuction(3, item)}>+</button>
                            </div>
                            : <button onClick={() => handleAllFuction(1, item)} className="btn_add w-full">{t("ADD")}</button>}
                    </div>
                </div>
            </div>
        )
    }
}

const AddonItem = ({ item, currency, setSelectAddon, selectaddon }) => {

    const isselect = selectaddon.some(addon => addon.title === item.title);

    const handleAddonAdd = () => {
        if (isselect) {
            const RemoveAddon = selectaddon.filter(addon => addon.title !== item.title);
            setSelectAddon(RemoveAddon);
        } else {
            setSelectAddon(prev => [...prev, item]);
        }
    }

    return (
        <div onClick={handleAddonAdd} className="py-[5px] cursor-pointer flex items-center justify-between gap-[10px]">
            <h1 className="text-gray-800 whitespace-nowrap overflow-hidden overflow-ellipsis">{item.title}</h1>
            <div className="flex items-center gap-[5px]">
                <p className="text-gray-800 text-[15px]">{currency}{item.price}</p>
                <div className={`${isselect ? "border-[--bgcolor] bg-[--bgcolor]" : "border-gray-500"} border-[2px] rounded-[5px]`}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 17.75C8.999 17.75 8.99799 17.75 8.99699 17.75C8.79699 17.749 8.60599 17.669 8.46499 17.526L4.46499 13.464C4.17399 13.169 4.178 12.694 4.473 12.403C4.768 12.113 5.24399 12.116 5.53399 12.411L9.003 15.935L18.469 6.46902C18.762 6.17602 19.237 6.17602 19.53 6.46902C19.823 6.76202 19.823 7.23705 19.53 7.53005L9.53 17.5301C9.39 17.6711 9.199 17.75 9 17.75Z" fill="white"></path>
                    </svg>
                </div>
            </div>
        </div>
    )
}

/* jshint ignore:end */